class LomiPasswordResetClient {
    constructor() {}

    sendPasswordResetEmail(username, onSuccess, onError) {
        aws_amplify.Amplify.Auth.forgotPassword(username)
            .then(data => onSuccess())
            .catch(err => {
                const userErr = {
                    userErrorMessage: err,
                }
                onError(userErr);
            });
    }

    resetPassword(code, username, new_password, onSuccess, onError) {
        // Collect confirmation code and new password, then
        aws_amplify.Amplify.Auth.forgotPasswordSubmit(username, code, new_password)
            .then(data => onSuccess())
            .catch(err => {
                const userErr = {
                    userErrorMessage: err,
                }
                onError(userErr);
            });
    }
}
